// @flow
import * as React from "react";

function Footer(): React.Node {
  return <footer />;
}

export default Footer;
